<div class="panel-shell automation-dialog">
  <header class="panel-header accent">
    <div class="panel-title text-bold">
      {{
        (mode === "CREATE"
          ? "AUTOMATIONS.CREATE_NEW"
          : "AUTOMATIONS.EDIT_TITLE"
        ) | translate
      }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body" [formGroup]="form">
    <!-- Nom -->
    <mat-form-field class="width-100" floatLabel="auto">
      <mat-label>{{ "AUTOMATIONS.NAME" | translate }} *</mat-label>
      <input matInput formControlName="name" autocomplete="nope" />
    </mat-form-field>

    <!-- DÉCLENCHEUR -->
    <div class="block">
      <div class="block-title">{{ "AUTOMATIONS.TRIGGER" | translate }}</div>
      <mat-radio-group
        formControlName="trigger_type"
        class="flex-row freq-radio"
      >
        <mat-radio-button value="SCHEDULE">{{
          "AUTOMATIONS.TRIGGER_SCHEDULE" | translate
        }}</mat-radio-button>
        <mat-radio-button
          value="EVENT"
          [disabled]="triggerEvents.length === 0"
          >{{ "AUTOMATIONS.TRIGGER_EVENT" | translate }}</mat-radio-button
        >
      </mat-radio-group>
      <mat-form-field
        *ngIf="isEventTrigger"
        class="width-100"
        floatLabel="auto"
      >
        <mat-label
          >{{ "AUTOMATIONS.TRIGGER_EVENT_SELECT" | translate }} *</mat-label
        >
        <mat-select formControlName="trigger_event" panelWidth="auto">
          <mat-option *ngFor="let item of triggerEvents" [value]="item.event">
            {{ eventLabel(item) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- QUOI -->
    <div class="block">
      <div class="block-title">{{ "AUTOMATIONS.WHAT" | translate }}</div>
      <!-- EVENT : tâche NOTIFICATION (sujet optionnel pour le courriel) -->
      <ng-container *ngIf="isEventTrigger">
        <div class="hint">
          {{ "AUTOMATIONS.TASK_NOTIFICATION_HINT" | translate }}
        </div>
        <mat-form-field
          *ngIf="!isWebhookAction"
          class="width-100"
          floatLabel="auto"
        >
          <mat-label>{{ "AUTOMATIONS.EMAIL_SUBJECT" | translate }}</mat-label>
          <input matInput formControlName="email_subject" autocomplete="nope" />
        </mat-form-field>
        <div *ngIf="!isWebhookAction" class="hint">
          {{ "AUTOMATIONS.EMAIL_SUBJECT_HINT" | translate }}
        </div>
        <mat-form-field style="max-width: 200px" floatLabel="auto">
          <mat-label>{{ "AUTOMATIONS.LANGUAGE" | translate }}</mat-label>
          <mat-select formControlName="locale">
            <mat-option value="fr-CA">Français</mat-option>
            <mat-option value="en-CA">English</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="!isEventTrigger">
        <!-- Type de tâche planifiée (affiché seulement si le catalogue en offre plusieurs) -->
        <mat-form-field
          *ngIf="hasTaskChoice"
          class="width-100"
          floatLabel="auto"
        >
          <mat-label>{{ "AUTOMATIONS.TASK_TYPE" | translate }}</mat-label>
          <mat-select formControlName="task_type" panelWidth="auto">
            <mat-option
              *ngFor="let taskType of scheduledTaskTypes"
              [value]="taskType.task_type"
            >
              {{ "AUTOMATIONS.TASK_" + taskType.task_type | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- PROPOSAL_FOLLOWUP : relance des propositions en attente -->
        <ng-container *ngIf="isFollowupTask">
          <div class="hint">
            {{ "AUTOMATIONS.TASK_PROPOSAL_FOLLOWUP_HINT" | translate }}
          </div>
          <div class="flex-row inline-fields">
            <mat-form-field style="max-width: 150px" floatLabel="auto">
              <mat-label
                >{{ "AUTOMATIONS.FOLLOWUP_STEP_1" | translate }} *</mat-label
              >
              <input
                matInput
                type="number"
                min="1"
                max="60"
                formControlName="followup_step_1"
              />
            </mat-form-field>
            <mat-form-field style="max-width: 150px" floatLabel="auto">
              <mat-label>{{
                "AUTOMATIONS.FOLLOWUP_STEP_2" | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                min="1"
                max="60"
                formControlName="followup_step_2"
              />
            </mat-form-field>
            <mat-form-field style="max-width: 150px" floatLabel="auto">
              <mat-label>{{
                "AUTOMATIONS.FOLLOWUP_STEP_3" | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                min="1"
                max="60"
                formControlName="followup_step_3"
              />
            </mat-form-field>
          </div>
          <div *ngIf="followupStepsInvalid" class="days-error">
            {{ "AUTOMATIONS.FOLLOWUP_STEPS_INVALID" | translate }}
          </div>
          <div class="hint">
            {{ "AUTOMATIONS.FOLLOWUP_STEPS_HINT" | translate }}
          </div>
          <mat-form-field style="max-width: 200px" floatLabel="auto">
            <mat-label>{{ "AUTOMATIONS.LANGUAGE" | translate }}</mat-label>
            <mat-select formControlName="locale">
              <mat-option value="fr-CA">Français</mat-option>
              <mat-option value="en-CA">English</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="hint">
            {{ "AUTOMATIONS.FOLLOWUP_TEMPLATE_HINT" | translate }}
          </div>
          <mat-checkbox formControlName="notify_internal" class="mt-8">
            {{ "AUTOMATIONS.FOLLOWUP_NOTIFY_INTERNAL" | translate }}
          </mat-checkbox>
          <mat-checkbox
            formControlName="notify_responsible_employee"
            class="mt-8"
          >
            {{ "AUTOMATIONS.FOLLOWUP_NOTIFY_SELLER" | translate }}
          </mat-checkbox>
        </ng-container>

        <mat-form-field
          *ngIf="!isFollowupTask"
          class="width-100"
          floatLabel="auto"
        >
          <mat-label>{{ "AUTOMATIONS.REPORT" | translate }} *</mat-label>
          <mat-select formControlName="report_key" panelWidth="auto">
            <mat-option
              *ngFor="let report of reports"
              [value]="report.report_key"
            >
              {{ reportLabel(report) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="!isFollowupTask" class="flex-row inline-fields">
          <mat-form-field floatLabel="auto">
            <mat-label>{{ "AUTOMATIONS.PAPER" | translate }}</mat-label>
            <mat-select formControlName="paper">
              <mat-option value="letter">{{
                "AUTOMATIONS.PAPER_LETTER" | translate
              }}</mat-option>
              <mat-option value="legal">{{
                "AUTOMATIONS.PAPER_LEGAL" | translate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field floatLabel="auto">
            <mat-label>{{ "AUTOMATIONS.ORIENTATION" | translate }}</mat-label>
            <mat-select formControlName="orientation">
              <mat-option value="portrait">{{
                "AUTOMATIONS.ORIENTATION_PORTRAIT" | translate
              }}</mat-option>
              <mat-option value="landscape">{{
                "AUTOMATIONS.ORIENTATION_LANDSCAPE" | translate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field floatLabel="auto">
            <mat-label>{{ "AUTOMATIONS.LANGUAGE" | translate }}</mat-label>
            <mat-select formControlName="locale">
              <mat-option value="fr-CA">Français</mat-option>
              <mat-option value="en-CA">English</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <!-- QUAND (planifié seulement) -->
    <div class="block" *ngIf="!isEventTrigger">
      <div class="block-title">{{ "AUTOMATIONS.WHEN" | translate }}</div>
      <mat-radio-group formControlName="freq" class="flex-row freq-radio">
        <mat-radio-button value="DAILY">{{
          "AUTOMATIONS.FREQ_DAILY" | translate
        }}</mat-radio-button>
        <mat-radio-button value="WEEKLY">{{
          "AUTOMATIONS.FREQ_WEEKLY" | translate
        }}</mat-radio-button>
        <mat-radio-button value="MONTHLY">{{
          "AUTOMATIONS.FREQ_MONTHLY" | translate
        }}</mat-radio-button>
      </mat-radio-group>

      <div *ngIf="form.value.freq === 'WEEKLY'" class="days-row">
        <div
          *ngFor="let day of weekDays"
          class="day-chip"
          [class.day-chip-on]="selectedDays[day]"
          (click)="toggleDay(day)"
        >
          {{ "AUTOMATIONS.DAY_SHORT_" + day | translate }}
        </div>
        <div *ngIf="weeklyMissingDays" class="days-error">
          {{ "AUTOMATIONS.SELECT_AT_LEAST_ONE_DAY" | translate }}
        </div>
      </div>

      <mat-form-field
        *ngIf="form.value.freq === 'MONTHLY'"
        style="max-width: 160px"
        floatLabel="auto"
      >
        <mat-label>{{ "AUTOMATIONS.MONTH_DAY" | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="1"
          max="31"
          formControlName="by_month_day"
        />
      </mat-form-field>

      <mat-form-field style="max-width: 160px" floatLabel="auto">
        <mat-label>{{ "AUTOMATIONS.TIME" | translate }} *</mat-label>
        <input matInput type="time" formControlName="run_time" />
      </mat-form-field>
    </div>

    <!-- PARAMÈTRE (planifié seulement, tâches datées seulement) -->
    <div class="block" *ngIf="!isEventTrigger && taskNeedsDateRange">
      <div class="block-title">{{ "AUTOMATIONS.PARAM" | translate }}</div>
      <div class="flex-row inline-fields">
        <mat-form-field floatLabel="auto">
          <mat-label>{{ "AUTOMATIONS.PERIOD" | translate }} *</mat-label>
          <mat-select formControlName="date_range_preset" panelWidth="auto">
            <mat-option value="TOMORROW">{{
              "AUTOMATIONS.PRESET_TOMORROW" | translate
            }}</mat-option>
            <mat-option value="TODAY">{{
              "AUTOMATIONS.PRESET_TODAY" | translate
            }}</mat-option>
            <mat-option value="NEXT_N_DAYS">{{
              "AUTOMATIONS.PRESET_NEXT_N_DAYS_OPTION" | translate
            }}</mat-option>
            <mat-option value="CURRENT_WEEK_PLUS_2">{{
              "AUTOMATIONS.PRESET_CURRENT_WEEK_PLUS_2" | translate
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          *ngIf="form.value.date_range_preset === 'NEXT_N_DAYS'"
          style="max-width: 140px"
          floatLabel="auto"
        >
          <mat-label>{{ "AUTOMATIONS.DAYS_COUNT" | translate }}</mat-label>
          <input
            matInput
            type="number"
            min="1"
            max="60"
            formControlName="date_range_days"
          />
        </mat-form-field>
      </div>
      <div class="hint">{{ "AUTOMATIONS.PERIOD_HINT" | translate }}</div>
    </div>

    <!-- ACTION -->
    <div class="block">
      <div class="block-title">{{ "AUTOMATIONS.ACTION" | translate }}</div>

      <mat-form-field
        *ngIf="actionTypes.length > 1"
        class="width-100"
        floatLabel="auto"
      >
        <mat-label>{{ "AUTOMATIONS.ACTION_TYPE" | translate }}</mat-label>
        <mat-select formControlName="action_type" panelWidth="auto">
          <mat-option *ngFor="let type of actionTypes" [value]="type">
            {{ "AUTOMATIONS.ACTION_" + type | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Webhook : POST JSON signé vers une URL https -->
      <ng-container *ngIf="isWebhookAction">
        <mat-form-field class="width-100" floatLabel="auto">
          <mat-label>{{ "AUTOMATIONS.WEBHOOK_URL" | translate }} *</mat-label>
          <input
            matInput
            formControlName="webhook_url"
            autocomplete="nope"
            placeholder="https://hooks.zapier.com/…"
          />
        </mat-form-field>
        <mat-form-field class="width-100" floatLabel="auto">
          <mat-label>{{ "AUTOMATIONS.WEBHOOK_SECRET" | translate }}</mat-label>
          <input
            matInput
            type="password"
            formControlName="webhook_secret"
            autocomplete="new-password"
            [placeholder]="hasStoredSecret ? '••••••••' : ''"
          />
        </mat-form-field>
        <div class="hint">{{ "AUTOMATIONS.WEBHOOK_HINT" | translate }}</div>
        <div *ngIf="hasStoredSecret" class="hint">
          {{ "AUTOMATIONS.WEBHOOK_SECRET_KEPT" | translate }}
        </div>
      </ng-container>

      <ng-container *ngIf="!isDriveAction && !isWebhookAction">
        <mat-form-field class="width-100" floatLabel="auto">
          <mat-label>{{ "AUTOMATIONS.EMAIL_TO" | translate }} *</mat-label>
          <input
            matInput
            formControlName="email_to"
            autocomplete="nope"
            placeholder="a@exemple.com, b@exemple.com"
          />
        </mat-form-field>
        <mat-form-field class="width-100" floatLabel="auto">
          <mat-label>{{ "AUTOMATIONS.EMAIL_CC" | translate }}</mat-label>
          <input matInput formControlName="email_cc" autocomplete="nope" />
        </mat-form-field>
        <mat-form-field class="width-100" floatLabel="auto">
          <mat-label>{{ "AUTOMATIONS.EMAIL_BCC" | translate }}</mat-label>
          <input matInput formControlName="email_bcc" autocomplete="nope" />
        </mat-form-field>
        <div class="hint">
          {{
            (isFollowupTask
              ? "AUTOMATIONS.FOLLOWUP_EMAIL_HINT"
              : "AUTOMATIONS.EMAIL_HINT"
            ) | translate
          }}
        </div>
      </ng-container>

      <!-- Google Drive / OneDrive : dépôt dans le Drive de l'organisation -->
      <ng-container *ngIf="isDriveAction">
        <div class="hint">
          {{
            (isOneDriveAction
              ? "AUTOMATIONS.ONEDRIVE_HINT"
              : "AUTOMATIONS.DRIVE_HINT"
            ) | translate
          }}
        </div>
        <mat-checkbox formControlName="overwrite" class="mt-8">
          {{ "AUTOMATIONS.DRIVE_OVERWRITE" | translate }}
        </mat-checkbox>
        <div class="hint">
          {{ "AUTOMATIONS.DRIVE_OVERWRITE_HINT" | translate }}
        </div>
      </ng-container>
    </div>

    <!-- Résumé vivant -->
    <div
      class="summary"
      *ngIf="
        isEventTrigger
          ? form.value.trigger_event
          : isFollowupTask || form.value.report_key
      "
    >
      <mat-icon class="s-16">info</mat-icon>
      <span>{{ summary }}</span>
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-space-between-center">
    <button mat-button (click)="close()">
      {{ "GENERIC.CANCEL" | translate }}
    </button>
    <button
      mat-raised-button
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
      [disabled]="
        form.invalid || weeklyMissingDays || followupStepsInvalid || loading
      "
      (click)="onSave()"
    >
      <mat-progress-spinner
        *ngIf="loading"
        diameter="18"
        mode="indeterminate"
      ></mat-progress-spinner>
      <span *ngIf="!loading">{{ "GENERIC.SAVE" | translate }}</span>
    </button>
  </footer>
</div>
